module.exports = __webpack_public_path__ + "img/0045.1c8eff55.jpg";